import firebase from "firebase";
import "firebase/firestore";
import firebaseConfig from "./firebaseConfig.js";

const firebaseApp = firebase.initializeApp(firebaseConfig);
const analytics = firebase.analytics();
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
const fieldValue = firebase.firestore.FieldValue;
const auth = firebase.auth();
const functions = firebase.functions();

const currentUser = auth.currentUser;

//date issue fix according to firebase
if (location.hostname === "localhost") {
  // db.settings({
  //   host: "localhost:8070",
  //   ssl: false
  // });
  // firebase.functions().useFunctionsEmulator("http://localhost:5001")
} else {
  const settings = {};
  db.settings(settings);
}

export { 
  db, 
  storage, 
  fieldValue, 
  auth, 
  analytics,
  functions,
  currentUser 
};
